webpackJsonp([196067925415476],{

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(41);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamMember = function TeamMember(props) {
	  var sizes = props.sizes;
	  var _props$data = props.data,
	      name = _props$data.name,
	      type = _props$data.type,
	      description = _props$data.description,
	      photo = _props$data.photo,
	      left = _props$data.left;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'row page-margin-top-section team-member' },
	    _react2.default.createElement(
	      'div',
	      { className: 'column column-1-2' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        name
	      ),
	      _react2.default.createElement(
	        'h5',
	        { className: 'box-header' },
	        type
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'description' },
	        description
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'column column-1-2' },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: sizes, imgStyle: { objectPosition: '0 0' }, style: { width: '100%' } })
	    )
	  );
	};
	
	exports.default = TeamMember;
	
	// return (
	//     <div className="row page-margin-top-section">
	//       <div className="column column-1-2">
	//         <Img sizes={sizes} imgStyle={{ objectPosition: '0 0' }} style={{ width: '100%' }} />
	//       </div>
	//       <div className="column column-1-2 align-right">
	//         <h3>{name}</h3>
	//         <h5 className="box-header">{type}</h5>
	//         <p className="description">{description}</p>
	//       </div>
	//     </div>
	//   );
	// };
	
	module.exports = exports['default'];

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(41);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Scroll = __webpack_require__(78);
	
	var _Scroll2 = _interopRequireDefault(_Scroll);
	
	var _TeamMember = __webpack_require__(318);
	
	var _TeamMember2 = _interopRequireDefault(_TeamMember);
	
	var _Hero = __webpack_require__(61);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _SEO = __webpack_require__(37);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SiteData = {
	  title: 'O nas',
	  slug: '/o-nas',
	  description: 'LUK & LUK Auto Serwis - Niezależny Serwis BMW istnieje w Raciborzu od 2003 roku. Na początku jego istnienia skupiał się na naprawie samochodów różnych marek ze specjalnością marki BMW.'
	};
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_SEO2.default, { isSeo: true, siteData: SiteData, type: 'Local Business' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'theme-page' },
	      _react2.default.createElement(
	        _Hero2.default,
	        { image: data.aboutHero.sizes, heading: 'Nasza historia i zesp\xF3\u0142' },
	        _react2.default.createElement(
	          'div',
	          { className: ' margin-top-67 padding-bottom-20' },
	          _react2.default.createElement(
	            _Scroll2.default,
	            { type: 'id', element: 'team' },
	            _react2.default.createElement(
	              'a',
	              { className: 'more', title: 'POZNAJ NAS BLI\u017BEJ' },
	              _react2.default.createElement(
	                'span',
	                null,
	                'poznaj nas bli\u017Cej'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'team', className: 'row gray full-width page-header vertical-align-table' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row full-width padding-top-bottom-50 vertical-align-cell' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'page-header-left' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'O nas'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page-header-right' },
	              _react2.default.createElement(
	                'div',
	                { className: 'bread-crumb-container' },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'JESTE\u015A TUTAJ:'
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'bread-crumb' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { to: '/' },
	                      'STRONA G\u0141\xD3WNA'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'separator' },
	                    '/'
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'O NAS'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row margin-top-70' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column column-1-2' },
	            _react2.default.createElement(
	              'p',
	              { className: 'description margin-top-0' },
	              'LUK & LUK Auto Serwis - Niezale\u017Cny Serwis BMW istnieje w Raciborzu od 2003 roku. Na pocz\u0105tku jego istnienia skupia\u0142 si\u0119 na naprawie samochod\xF3w r\xF3\u017Cnych marek ze specjalno\u015Bci\u0105 marki BMW.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'margin-top-10' },
	              'W miar\u0119 up\u0142ywu czasu klienci z samochodami marki BMW stanowili coraz wi\u0119kszy udzia\u0142 procentowy serwisu, co spowodowa\u0142o skupienie si\u0119 serwisu na naprawie pojazd\xF3w tylko tego producenta.',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              'Jako niezale\u017Cny serwis BMW \u015Bwiadczymy bardzo szeroki zakres us\u0142ug. Pocz\u0105wszy od okresowych przegl\u0105d\xF3w, wymiany opon i mechaniki, po kodowanie, zaawansowan\u0105 diagnostyk\u0119 i naprawy powypadkowe. ',
	              _react2.default.createElement('br', null),
	              'Posiadamy specjalistyczny sprz\u0119t, kt\xF3ry w po\u0142\u0105czeniu z do\u015Bwiadczeniem i szerok\u0105 wiedz\u0105 pozwala szybko i w pe\u0142ni zdiagnozowa\u0107 usterk\u0119 i rozwi\u0105za\u0107 problemy. ',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              'Nasze us\u0142ugi cechuje wysoka jako\u015B\u0107, solidno\u015B\u0107 oraz uczciwo\u015B\u0107. Klienta traktujemy priorytetowo a ich samochody z odpowiedni\u0105 dba\u0142o\u015Bci\u0105.'
	            ),
	            _react2.default.createElement(
	              'h4',
	              { className: 'box-header margin-top-26' },
	              'DLACZEGO LUK & LUK?'
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'list margin-top-30' },
	              _react2.default.createElement(
	                'li',
	                { className: 'template-bullet' },
	                'Otwarto\u015B\u0107 i transparentnos\u0107\xA0w relacjach z klientami'
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'template-bullet' },
	                'Szybkie i precyzyjne diagnozy usterek'
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'template-bullet' },
	                'Fachowa wiedza potwierdzona licznymi certyfikatami'
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'template-bullet' },
	                'Ka\u017Cdy cz\u0142onek zespo\u0142u to prawdziwy fanatyk BMW \uD83D\uDE01'
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'template-bullet' },
	                'Terminowo\u015B\u0107 w naprawach'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page-margin-top mobile-center' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/uslugi', className: 'more' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'zobacz ofert\u0119'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column column-1-2' },
	            _react2.default.createElement(_gatsbyImage2.default, { sizes: data.aboutGallery_01.sizes, imgStyle: { objectPosition: '0 0' }, style: { width: '100%' } }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row margin-top-30' },
	              _react2.default.createElement(
	                'div',
	                { className: 'column column-1-2' },
	                _react2.default.createElement(_gatsbyImage2.default, {
	                  sizes: data.aboutGallery_02.sizes,
	                  imgStyle: { objectPosition: '0 0' },
	                  style: { width: '100%' }
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'column column-1-2' },
	                _react2.default.createElement(_gatsbyImage2.default, {
	                  sizes: data.aboutGallery_03.sizes,
	                  imgStyle: { objectPosition: '0 0' },
	                  style: { width: '100%' }
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row gray full-width page-margin-top-section page-padding-top padding-bottom-66' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column column-1-4 align-center' },
	              _react2.default.createElement(
	                'span',
	                { className: 'number sign' },
	                '99.9%'
	              ),
	              _react2.default.createElement(
	                'h5',
	                { className: 'margin-top-10' },
	                'ZADOWOLENIA',
	                _react2.default.createElement('br', null),
	                'KLIENTA'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column column-1-4 align-center' },
	              _react2.default.createElement(
	                'span',
	                { className: 'number sign' },
	                '99.9%'
	              ),
	              _react2.default.createElement(
	                'h5',
	                { className: 'margin-top-10' },
	                'RZETELNO\u015ACI'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column column-1-4 align-center' },
	              _react2.default.createElement(
	                'span',
	                { className: 'number sign' },
	                '99.9%'
	              ),
	              _react2.default.createElement(
	                'h5',
	                { className: 'margin-top-10' },
	                'NAPRAWIONYCH',
	                _react2.default.createElement('br', null),
	                'BMW'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column column-1-4 align-center' },
	              _react2.default.createElement(
	                'span',
	                { className: 'number sign' },
	                '99.9%'
	              ),
	              _react2.default.createElement(
	                'h5',
	                { className: 'margin-top-10' },
	                'JAKO\u015ACI'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row page-margin-top-section padding-bottom-66' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'box-header' },
	              'NASZ ZESP\xD3\u0141'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'description align-center' },
	              'Poznaj ka\u017Cdego z cz\u0142onk\xF3w naszego zespo\u0142u.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'team' },
	            data.team.edges.map(function (member) {
	              var photo = member.node.photo;
	
	              return _react2.default.createElement(_TeamMember2.default, { key: member.node.name, data: member.node, sizes: data[photo].sizes });
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row gray full-width padding-top-54 padding-bottom-61 align-center' },
	          _react2.default.createElement(
	            'h3',
	            { style: { lineHeight: 2.5 } },
	            _react2.default.createElement(
	              'span',
	              { className: 'button-label' },
	              'CHCESZ Z NAMI WSP\xD3\u0141PRACOWA\u0106 LUB MASZ JAKIE\u015A PYTANIA?'
	            ),
	            ' ',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: 'more', to: '/kontakt', style: { display: 'inline-block' } },
	              _react2.default.createElement(
	                'span',
	                null,
	                'skontaktuj si\u0119'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-o-nas-js-444f3f922f10ee5c10f2.js